"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cciIssues = void 0;
//@ts-nocheck
exports.cciIssues = {
    tenantId: {
        uuid: "ABCCCEEA-6193-4575-B90D-C7E657C0B922"
    },
    healthSystemTenantId: {
        uuid: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59"
    },
    guid: {
        uuid: "7c6d2b95-8301-4f4e-9fdf-4db1a9034ed3"
    },
    serviceLine: "PATHOLOGY",
    gender: "M",
    dateOfBirth: "1984-04-10",
    age: 38,
    hl7InsurancePayerId: "1006",
    hl7InsurancePlanId: "100604",
    cmxInsurancePayerId: "98",
    status: "IN_PROGRESS",
    sharedDiagnosisCodes: [
        {
            diagnosis_code: "L02.91",
            sequence_number: 1,
            evidence: [],
            additionalProperties: {
                id: 9095
            },
            shared: true,
            active: true
        }
    ],
    errors: [
        {
            field: "invoices",
            message_key: "invoice.cci_edit.invalid",
            message: '{"88305":"[{\\"status\\":\\"2\\",\\"message\\":\\"Cannot be billed with 88321 unless documentation supports adding NCCI-appropriate modifier.\\"}]"}',
            source: "CCI_EDIT"
        },
        {
            field: "invoices",
            message_key: "invoice.claims_edit.invalid",
            message: '{"88305":"[{\\"policy\\":\\"C-030-0089\\",\\"status\\":\\"Error\\",\\"message\\":\\"Per policy C-030-0089, HCPCS 88305 is a non-covered service.\\",\\"categoryCode\\":\\"A13\\"},{\\"policy\\":\\"C-030-0372\\",\\"status\\":\\"Warning\\",\\"message\\":\\"Per policy C-030-0372, HCPCS 88305 is a non-covered service.\\",\\"categoryCode\\":\\"A13\\"},{\\"policy\\":\\"C-030-A004\\",\\"status\\":\\"Error\\",\\"message\\":\\"Per policy C-030-A004, HCPCS 88305 with diagnosis L02.91 does not meet medical necessity.\\",\\"categoryCode\\":\\"A04\\"},{\\"policy\\":\\"C-030-0504\\",\\"status\\":\\"Error\\",\\"message\\":\\"Per policy C-030-0504, HCPCS 88305 is a non-covered service.\\",\\"categoryCode\\":\\"A13\\"}]","Z01.419":"[{\\"status\\":\\"Error\\",\\"message\\":\\"invalid gender for diagnosis\\"}]","G0141":"[{\\"policy\\":\\"C-030-A004\\",\\"status\\":\\"Warning\\",\\"message\\":\\"Per policy C-030-A004, Diagnosis code may meet medical necessity; please see note associated with CPT code G0141.\\",\\"categoryCode\\":\\"A10\\"},{\\"policy\\":\\"210.2\\",\\"status\\":\\"Error\\",\\"message\\":\\"Per policy 210.2, HCPCS G0141 with diagnosis L02.91 does not meet medical necessity.\\",\\"categoryCode\\":\\"A04\\"},{\\"policy\\":\\"C-030-A004\\",\\"status\\":\\"Warning\\",\\"message\\":\\"Per policy C-030-A004, Diagnosis code may meet medical necessity; please see note associated with CPT code G0141.\\",\\"categoryCode\\":\\"A10\\"},{\\"policy\\":\\"210.2\\",\\"status\\":\\"Warning\\",\\"message\\":\\"Per policy 210.2, HCPCS G0141 with diagnosis Z01.419 meets medical necessity but has additional restrictions based on age, gender and/or frequency; (see policy)\\",\\"categoryCode\\":\\"A04\\"}]","Z34.01":"[{\\"status\\":\\"Error\\",\\"message\\":\\"invalid gender for diagnosis\\"}]"}',
            source: "CLAIMS_EDIT"
        },
        {
            error_version: "2",
            error_status: "Error",
            field: "transaction",
            message_key: "invoice.custom_rules.invalid",
            message: "This service requires one of the following modifiers to be completed: NS, GC, ST",
            source: "CUSTOM_RULES",
            code: "40202",
            invoice_guid: "247dab25-0173-44a0-9db2-5a0bd15b5bbd",
            transaction_guid: "db6304a3-8642-4898-ab3c-9c70b8f9f37d",
            case_uid: "0ed9d159-e339-47b0-9dff-1d65a591a10f",
            caserun_uid: "9110f6a3-30f9-4cea-ac5e-dc72657a717e"
        }
    ],
    invoices: [
        {
            type: "assembled",
            guid: "650648ea-cb5e-4816-9597-07d5fcd33fac",
            date_of_service: "2023-02-27",
            datetime_of_service: "2023-02-27 00:00:00 EST",
            department_code: "10030010328",
            patient_type: "",
            billing_location: null,
            billing_area: null,
            division: null,
            facility: null,
            filler_number: {
                number: "PATH_CMX_AUT_014_match_charges_and_roll_up_units_pro_only_codes-2023-3366d187faf04aa28870deb4826c82f1",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: null,
            billing_provider_number: {
                number: "1521674",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: "1013009",
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: "1521674",
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [
                {
                    guid: "1d63d028-d911-4c95-89e0-9194c0a5bb6a",
                    sequence_number: 1,
                    source_transaction_id: "S17755002",
                    deleted: false,
                    technical_code: null,
                    procedure: {
                        procedure_code: "88321",
                        units: 5.0,
                        sequence_number: 1,
                        custom_cpt: false,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 10310
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "88321",
                        units: 5.0,
                        sequence_number: 1,
                        custom_cpt: false,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 10311
                        }
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "L02.91",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 9095
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "Z34.01",
                            sequence_number: 2,
                            evidence: [],
                            additionalProperties: {
                                id: 9101
                            },
                            shared: false,
                            active: true
                        }
                    ],
                    fee_schedule: "5000356",
                    place_of_service: "BWH_MCIRTUM"
                },
                {
                    guid: "95271e28-1a4b-4d04-90c0-3fc0d6c71a4f",
                    sequence_number: 2,
                    source_transaction_id: "S17755003",
                    deleted: false,
                    technical_code: {
                        units: 1.0,
                        code: "31000150",
                        sequence_number: 1,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 2725
                        }
                    },
                    procedure: {
                        procedure_code: "88305",
                        units: 1.0,
                        sequence_number: null,
                        custom_cpt: false,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 10316
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "88305",
                        units: 1.0,
                        sequence_number: 1,
                        custom_cpt: true,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 10317
                        }
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "L02.91",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 9096
                            },
                            shared: true,
                            active: true
                        }
                    ],
                    fee_schedule: "5000356",
                    place_of_service: "BWH_MCIRTUM"
                },
                {
                    guid: "918ff768-3637-4333-ab12-e96d5cd257c3",
                    sequence_number: 3,
                    source_transaction_id: null,
                    deleted: false,
                    technical_code: null,
                    procedure: {
                        procedure_code: "G0141",
                        units: 1.0,
                        sequence_number: null,
                        custom_cpt: false,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 10339
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "G0141",
                        units: 1.0,
                        sequence_number: 1,
                        custom_cpt: true,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 10340
                        }
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "L02.91",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 9098
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "Z01.419",
                            sequence_number: 2,
                            evidence: [],
                            additionalProperties: {
                                id: 9100
                            },
                            shared: false,
                            active: true
                        }
                    ],
                    fee_schedule: "5000356",
                    place_of_service: null
                }
            ],
            deleted: false,
            health_plan_id: null
        }
    ],
    cancelled: false
};
//# sourceMappingURL=cci-issues.js.map